import apiCall from '../index'
import config from '../config'

const apiService = '/gsencuesta/api/v1/tablero_indicador'

const service = {
  findEncuestador(params) {
    const query = `?limit=${params.limit}&page=${params.page}&query=${params.query}&sortBy=${params.sortBy}&fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}&idEncuesta=${params.idEncuesta}&idProyecto=${params.idProyecto}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(`${apiService}/encuestador${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  printConsolidadoFicha(params) {
    const query = `?idEncuesta=${params.idEncuesta}&fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}&idUsuario=${params.selectUsuario}`
    return `${config.baseURL}${apiService}/consolidado_fichas/${query}`
  },
  printConsolidadoFicha2(params) {
    const query = `?idEncuesta=${params.idEncuesta}&fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}&idUsuario=${params.selectUsuario}`
    return `${config.baseURL}${apiService}/consolidado_fichas_2/${query}`
  },
  printConsolidadoFichaPdf(params) {
    const query = `?idEncuesta=${params.idEncuesta}&fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}&idUsuario=${params.selectUsuario}`
    return `${config.baseURL}${apiService}/consolidado_fichas_pdf/${query}`
  },
  printFichaPdf(params) {
    const query = `?&idFicha=${params.idFicha}`
    return `${config.baseURL}${apiService}/ficha_pdf/${query}`
  },
  findReportAll(params) {
    const query = `?fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}&idEncuesta=${params.idEncuesta}&idProyecto=${params.idProyecto}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(`${apiService}/reportAll${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findReportLineaTiempo(params) {
    const query = `?fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}&idEncuesta=${params.idEncuesta}&idProyecto=${params.idProyecto}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(`${apiService}/linea_tiempo${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findReportPreguntaRespuesta(params) {
    const query = `pregunta_respuesta?idFicha=${params.idFicha}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(`${apiService}/${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
